import PropTypes from 'prop-types';
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { display, left, space, position, top } from 'styled-system';

const growShrink = keyframes`
  0% {
    transform:scale(1,1);
  }
  50% {
    transform:scale(2,2);
  }
  100% {
    transform:scale(1,1);
  }
`;

const SpinnerDiv = styled.div`
  ${display}
  ${position}
  ${space}
  ${left}
  ${top}
  text-align: center;
  z-index: 4;
`;

const Dot = styled.div`
    animation-name: ${growShrink};
    animation-duration: 1.4s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;
    background-color: ${props => props.theme.colors.green};
    padding: 5px
    margin-right: 5px;
    margin-left: 5px;
    border-radius: 10px;
    display: inline-block;
    vertical-align: middle;
    
    &:nth-child(2) {
      animation-delay: .2s;
    }

    &:nth-child(3) {
    animation-delay: .4s;
}
`;

const Spinner = ({message, type}) => (
  <SpinnerDiv
    display={type !== 'center' ? 'inline-flex' : 'block'}
    position={type !== 'inline' && type !== 'center' && 'fixed'}
    ml={!type && '-30px'}
    left={type !== 'inline' && '50%'}
    top={type !== 'inline' && '50%'}>
    <Dot /><Dot /><Dot />
    <span>{message}</span>
  </SpinnerDiv>
);

Spinner.propTypes = {
  message: PropTypes.string,
  type: PropTypes.oneOf(['inline', 'center']),
};

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/Spinner.jsx